import { Vault } from '@/features/vaults/types';
import { GGTokenAddress } from '@/features/vaults/constants/vaults/lido/tokens/GGTokenAddress';
import { DVstETHTokenAddress } from '@/features/vaults/constants/vaults/lido/tokens/DVstETHTokenAddress';
import { strETHTokenAddress } from '@/features/vaults/constants/vaults/lido/tokens/strETHTokenAddress';
import { LidoStrategyTitleHeader } from '@/shared/components/WhiteLabelTitleHeaders/LidoStrategyTitleHeader';

export const lidoEarnEthVaultId = 'earn-eth';

export const lidoEarnEth: Vault = {
  id: lidoEarnEthVaultId,
  type: 'core-vault',
  name: 'EarnETH',
  description:
    'EarnETH provides on-chain access to strategies involving ETH-denominated digital assets. It uses defined asset selection and risk controls, supported by transparent reporting.',
  category: 'core-vault',
  address: '0x6a37725ca7f4CE81c004c955f7280d5C704a249e',
  whiteLabeling: {
    curatorId: 'mellow',
    subdomain: 'earn-eth',
  },
  curators: ['lido', 'mellow'],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x6a37725ca7f4CE81c004c955f7280d5C704a249e',
    },
  ],
  additionalDepositTokens: [
    {
      address: strETHTokenAddress,
      decimals: 18,
      symbol: 'strETH',
    },
    {
      address: DVstETHTokenAddress,
      decimals: 18,
      symbol: 'DVstETH',
    },
    {
      address: GGTokenAddress,
      decimals: 18,
      symbol: 'GG',
    },
  ],
  baseToken: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  lpTokenSymbol: 'earnETH',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  callConfigOrigin: {
    branch: 'main',
    filenamePrefix: 'ethereum:earnETH',
  },
  allocations: {
    showAllocationsTab: true,
    showAllocationsTable: true,
    octavProLink: 'https://mellow.octav.fi/app/earnETH',
    debankBundleId: '221533',
  },
  vaultTitleHeader: <LidoStrategyTitleHeader link="https://stake.lido.fi/earn/eth/deposit" />,
  displayNoMellowCuration: true,
  deposit: {
    disabled: true,
    disabledReason:
      'Deposits and withdrawal processing for EarnETH are currently paused by the vault curator, pending resolution of the Kelp and Aave incident.',
  },
};
